// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3fpS9","header":"Messages_header__sXYkC"};